import React, { Suspense, lazy } from 'react';
import './App.css';
import Home from './Pages/Home';
import Header from './Components/Header';
import Footer from './Components/Footer';
import StructuredData from './Components/StructuredData';
import FAQSchema from './Components/FAQSchema';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';

// Lazy load des pages moins critiques pour améliorer le temps de chargement initial
const About = lazy(() => import('./Pages/About'));
const Services = lazy(() => import('./Pages/Services'));
const Forms = lazy(() => import('./Pages/Forms'));
const Contact = lazy(() => import('./Pages/Contact'));
const LegalMentions = lazy(() => import('./Pages/LegalMentions'));
const PrivacyPolicy = lazy(() => import('./Pages/PrivacyPolicy'));
const TermsOfSale = lazy(() => import('./Pages/TermsOfSale'));
const NotFound = lazy(() => import('./Pages/NotFound'));
const WorkInProgress = lazy(() => import('./Pages/WorkInProgress'));

function App() {
  return (
    <Router>
      <LanguageProvider>
        <StructuredData />
        <FAQSchema />
        <div className="App">
          <Header/>
          <Suspense fallback={<div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Chargement...</div>}>
            <Routes>
              {/* Redirection racine vers /fr/home par défaut */}
              <Route path="/" element={<Navigate to="/fr/home" replace />} />
              
              {/* Redirections /lang/ vers /lang/home */}
              <Route path="/fr" element={<Navigate to="/fr/home" replace />} />
              <Route path="/de" element={<Navigate to="/de/home" replace />} />
              
              {/* Routes sans préfixe (redirigées automatiquement par LanguageContext) */}
              <Route path="/home" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/forms" element={<Forms />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/mentions-legales" element={<LegalMentions />} />
              <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
              <Route path="/cgv" element={<TermsOfSale />} />
              <Route path="/work-in-progress" element={<WorkInProgress />} />
              
              {/* Routes avec préfixe de langue */}
              <Route path="/:lang/home" element={<Home />} />
              <Route path="/:lang/about" element={<About />} />
              <Route path="/:lang/services" element={<Services />} />
              <Route path="/:lang/forms" element={<Forms />} />
              <Route path="/:lang/contact" element={<Contact />} />
              <Route path="/:lang/mentions-legales" element={<LegalMentions />} />
              <Route path="/:lang/politique-confidentialite" element={<PrivacyPolicy />} />
              <Route path="/:lang/cgv" element={<TermsOfSale />} />
              <Route path="/:lang/work-in-progress" element={<WorkInProgress />} />
              
              {/* 404 - Catch all */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <Footer/>
        </div>
        <Analytics />
        <SpeedInsights />
      </LanguageProvider>
    </Router>
  );
}

export default App;
